import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { FaCashRegister, FaEdit, FaEye, FaFilePdf, FaFolderOpen, FaPlus, FaPrint, FaTimes, FaTrash } from 'react-icons/fa';
import Modal from '../../../components/Modal';
import { formatDate, formatToZMW, rootUrl } from '../../../helpers';
import { useAuth } from '../../../context/auth-context';
import DataTable from "react-data-table-component";
import Receipt from '../../../components/reciept';
import PaymentVoucher from '../../../components/PaymentVoucher';
import ReactToPrint from 'react-to-print';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import FormGenerator from '../../../components/formGenerator';
import { BiTransfer } from "react-icons/bi";
import { toast } from 'react-toastify';
import { customStyles } from '../../../styles';
import Select from 'react-select';

const CashbookPage = () => {
  const [cashbooks, setCashbooks] = useState([]);
  const [filteredCashbooks, setFilteredCashbooks] = useState([]);
  const [selectedCashbook, setSelectedCashbook] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState({
    fromCash: '',
    toCash: '',
    amount: '',
    description: '',
  });
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    bank: '',
    customer: '',
    search: '',
  });

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editData, setEditData] = useState({ id: "", date: "", description: "", project:''});

  const [isOpen, setIsOpen] = useState(false);
  const [selectedObj, setSelectedObj] = useState(null);
  const [comment, setComment] = useState("");

  const openModal = (obj) => {
    setSelectedObj(obj);
    setIsOpen(true);
  };

  const getOptionDetails = (option) => {
    const coaDetails = allData.coa?.find((a) => a.account == option.coa) || {};
    return {
        value: option.id,
        label: `${option.coa} - 
        ${coaDetails.name || ''} -
        ${allData.program.find(a=>a.programCode == option.program)?.name  || ''} -
        ${allData.subProgram.find(a=>parseFloat(a.subProgramCode) == parseFloat(option.subprogram)
        && a.programCode == option.program
        )?.name  || ''} -
        ${option.toy || ''} - 
        ${allData.dept.find(a=>a.id == option.dept)?.name  || ''}
        `
    };
};

  const {allData, setAllData} = useOutletContext();
  const handleEdit = (row) => {
    const prj = allData.projects.filter(a=>a.id == row.proj_id)?.map((res)=>({value:res.id, label:res.name}))[0]
    const Ebank = allData.bank.filter(a=>a.id == row.bank)?.map((res)=>({value:res.id, label:res.name}))[0]
    const ebudg = allData.budget.filter(a=>a.id == row.coa_id)?.map(getOptionDetails)[0]
    // const Epayee = allData.suppliers.filter(a=>a.id == row.paye)?.map((res)=>({value:res.id, label:res.name}))
    setEditData({ id: row.id, date: new Date(row.date).toISOString().split('T')[0], 
      description: row.description, project: prj , bank:Ebank, coa_id:ebudg});
    setIsEditModalOpen(true);
  };

  

  // Handle input change
  const handleChange = (e) => {    
      setEditData({ ...editData, [e.target.name]: e.target.value });
      
  };

  const handleSelectChange = (data, name) => {

      if(data == null){
        setEditData({ ...editData, [name]:'' });
        return
      }
      setEditData({ ...editData, [name]:data});
  
  }



  // Submit updated values
  const handleSubmit =  () => {

    editData['uid'] = auth.user.id
       axios.post(rootUrl(`/editCash`), editData)
      toast.success("Successful")
      updateRow(editData);
      setIsEditModalOpen(false);
  };


  const updateRow = (updatedRow) => {
    setFilteredCashbooks((prev) =>
      prev.map((row) =>
        row.id === updatedRow.id
          ? { ...row, description: updatedRow.description, date: updatedRow.date, proj_id:updatedRow.project?.value, bank:updatedRow.bank.value }
          : row
      )
    );
  };  

  const [showSlidingDiv, setShowSlidingDiv] = useState(false);
  const [output, setOutput] = useState('');
  const [title, setTitle] = useState('');

  const auth = useAuth();

  const componentRef = useRef(null);

 const right = parseInt(auth.user.userType) === 2

function handleExportToPDF() {
  const input = componentRef.current;
  html2canvas(input).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${title}.pdf`);
  });
}

const handlePrint = () => {
  const printContent = componentRef.current;
  const printWindow = window.open("", "", "width=800,height=600");

  printWindow.document.open();
  printWindow.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <script src="https://cdn.tailwindcss.com"></script>
        <style>
          @media print {
            body { margin: 20px; }
          }
        </style>
      </head>
      <body class="p-4">${printContent.innerHTML}</body>
    </html>
  `);
  printWindow.document.close();

  // Ensure Tailwind is applied before printing
  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};


  // Fetch cashbooks data
  useEffect(() => {
    axios
      .get(rootUrl(`/getCash/${auth.user.id}`))
      .then((response) => {
        setCashbooks(response.data.data);
        setFilteredCashbooks(response.data.data);

      })
      .catch((error) => console.error('Error fetching cashbooks:', error));
  }, [auth.user.cid]);

  // Filter cashbooks
  useEffect(() => {
    let filtered = cashbooks;

    if (filters.startDate) {
      filtered = filtered.filter((row) => {
        const rowDate = new Date(row.date);
        const startDate = new Date(filters.startDate);
      
        // Set the time part to midnight (00:00:00) for both dates
        rowDate.setHours(0, 0, 0, 0);
        startDate.setHours(0, 0, 0, 0);
      
        return rowDate >= startDate;
      });
    }
    if (filters.endDate) {
      filtered = filtered.filter((row) => {
        const rowDate = new Date(row.date);
        const endDate = new Date(filters.endDate);
      
        // Set the time part to midnight (00:00:00) for both dates
        rowDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
      
        return rowDate <= endDate;
      });
    }
    if (filters.bank) {
      filtered = filtered.filter((row) => row.bank == filters.bank);
    }
    if (filters.customer) {
      filtered = filtered.filter((row) => row.paye == filters.customer);
    }
    if (filters.search) {
      filtered = filtered.filter(
        (row) =>
          row.description?.toLowerCase().includes(filters.search.toLowerCase()) ||
        row.voucher?.toLowerCase().includes(filters.search.toLowerCase()) ||
        row.cheque?.toLowerCase().includes(filters.search.toLowerCase()) 
      );
    }
    setFilteredCashbooks(filtered);
  }, [filters, cashbooks, allData]);

  const openSlidingDiv = () => {
    setShowSlidingDiv(true);
  };

  const closeSlidingDiv = () => {
    setShowSlidingDiv(false);
  };

  console.log(allData)

  const calculateBalance = () => {
    let balance = 0;


    return filteredCashbooks.map((row) => {
      if (parseInt(row.status) === 3) { // Only update balance if status is 3
        balance += row.type === 'income' ? parseFloat(row.amount) : -parseFloat(row.amount);
      }
      return { ...row, balance };
    });
  };

  const display = (obj) => {
    openSlidingDiv();
    if (obj.type === 'income') {
      setTitle("Receipt");
      setOutput(<Receipt data={cashbooks.filter(a=>a.voucher == obj.voucher)} ref={componentRef} />);
    } else {
      setTitle("Payment Voucher");
      setOutput(<PaymentVoucher data={obj} ref={componentRef} />);
    }
  };


  const handleDelete = async () => {
    if (!selectedObj) return;

    try {
      await axios.post(rootUrl(`/delCash`), {
        id: selectedObj.id,
        type: selectedObj.type,
        comment: comment, 
        voucher:selectedObj.voucher, 
        amount:selectedObj.amount,
        uid:auth.user.id
      });

      toast.success("Successful")
      setFilteredCashbooks((prev) =>
        prev.filter((item) => item.id !== selectedObj.id)
      );
      setIsOpen(false);
      setComment("");
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };

  
  const columns = [
    {
      name: 'Sn',
      selector: (row, index) => index + 1,
      sortable: true,
      width: '50px',
    },
    {
      name: 'Date',
      selector: (row) => formatDate(row.date.substring(0, 10)),
      sortable: true,
    },
    {
      name: 'Chart of Account',
      selector: (row) =>
        allData?.budget?.find((a) => a.id == row.coa_id)?.coa || '',
      sortable: true,
    },
    {
      name: 'Bank',
      selector: (row) =>
        allData?.bank?.find((a) => a.id == row.bank)?.name || '',
      sortable: true,
    },
    {
      name: 'Description',
      selector: (row) => row.description || '',
      sortable: true,
    },
    {
      name: 'Voucher #',
      selector: (row) => row.voucher || '',
      sortable: true,
    },{
      name: 'Cheque #',
      selector: (row) => row.cheque || '',
      sortable: true,
    },
    {
      name: 'Payee',
      selector: (row) => allData?.suppliers?.find((a) => a.id == row.paye)?.name || ''
        
      ,
      sortable: true,
    },
    {
      name: 'Project',
      selector: (row) => allData?.projects?.find((a) => a.id == row.proj_id)?.name || ''
      ,
      sortable: true,
    },
    {
      name: 'Debit',
      selector: (row) => (row.type === 'income' ? formatToZMW(row.amount) : 0),
      sortable: true,
    },
    {
      name: 'Credit',
      selector: (row) => (row.type === 'expense' ? formatToZMW(row.amount) : 0),
      sortable: true,
    },
    // {
    //   name: 'Cashbook',
    //   selector: (row) => allData?.bank?.find((a) => a.id === row.bank)?.name || '',
    //   sortable: true,
    // },
 
    {
      name: 'Balance',
      selector: (row) => formatToZMW(row.balance || 0),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
      
        <>
        <button
          className="bg-blue-950 hover:bg-blue-950 text-white px-3 py-1 m-1 rounded"
          onClick={() => display(row)}
        >
          <FaEye/>
        </button>
        <button
        className="bg-red-900 hover:bg-blue-950 text-white px-3 py-1 m-1 rounded"
        onClick={() => openModal(row)}
       
      >
        <FaTrash/>
      </button>
      <button
        className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded"
        onClick={() => handleEdit(row)}
       
                    >
        <FaEdit />
      </button>
      </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const finalBalance = filteredCashbooks.reduce((total, row) => {
    if (parseInt(row.status) === 3) { // only status 3
      const amount = parseFloat(row.amount) || 0; 
      return row.type === 'income' ? total + amount : total - amount;
    }
    return total; // if not status 3, don't change total
  }, 0);
  

 async function onsubmit(formdata) {

  formdata['uid'] = auth.user.id

      try{

        const response = await axios.post(rootUrl(`/transfer`), formdata)
        if(response.status === 200){
          toast.success("Added successfully")
          setIsModalVisible(false)
          axios
          .get(rootUrl(`/getCash/${auth.user.id}`))
          .then((response) => {
            setCashbooks(response.data.data);
            setFilteredCashbooks(response.data.data);
          })
          .catch((error) => console.error('Error fetching cashbooks:', error));
        } 

      }catch(error){
        toast.error(error?.message)
      }

  }

   
       const [fields, setFields] = useState([]);
 
       useEffect(() => {
         if (allData.bank !== undefined) {
           setFields([
          
             {
               type: 'select',
               name: 'fromBank',
               label: 'From',
               required: true,
               options: allData.bank.map(res => ({
                 value: res.id,
                 label: res.name,
               })),
             },
             {
               type: 'select',
               name: 'toBank',
               label: 'To',
               required: true,
               options: allData.bank.map(res => ({
                 value: res.id,
                 label: res.name,
               })),
             },
             { type: 'text', name: 'amount', label: 'Amount', required: true },
             { type: 'date', name: 'date', label: 'Date', required: true },
             { type: 'textarea', name: 'description', label: 'Description' },
           ]);
         }
       }, [allData]);

       const customerOptions = [...new Set(cashbooks.map(res => res.paye))].map((cust) => {
        const supplier = allData?.suppliers.find(a => a.id == cust);
        return {
          value: cust,
          label: supplier?.name || cust,
        };
      });
       

  return (
    <div className="cashbook-page">
      {/* Cashbook Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="font-bold text-2xl flex items-center">
          <FaCashRegister className="mr-2" /> Transaction List
        </h1>
        <button
          className="border p-2 rounded-lg flex items-center bg-blue-950 text-white"
          onClick={() => setIsModalVisible(true)}
        >
          <BiTransfer  className="mr-2" />  Transfer
        </button>
      </div>

      <hr className="my-2" />

      {/* Filters */}
      <div className="grid grid-cols-3 gap-4 mb-4">
        <input
          type="date"
          className="border px-3 py-2 rounded"
          value={filters.startDate}
          onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
        />
        <input
          type="date"
          className="border px-3 py-2 rounded"
          value={filters.endDate}
          onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
        />
        <select
          className="border px-3 py-2 rounded"
          value={filters.bank}
          onChange={(e) => setFilters({ ...filters, bank: e.target.value })}
        >
          <option value="">All CashBooks</option>
          {allData?.bank?.map((bank) => (
            <option key={bank.id} value={bank.id}>{bank.name}</option>
          ))}
        </select>

        <Select
        options={customerOptions}
        placeholder="Payee"
        isClearable
        value={customerOptions.find(option => option.value === filters.customer)}
        onChange={(selectedOption) =>
          setFilters({ ...filters, customer: selectedOption ? selectedOption.value : "" })
        }
      />
        <input
          type="text"
          placeholder="Search..."
          className="border px-3 py-2 rounded"
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />
      </div>

      
      <span className='text-gray-800 pt-5 text-small'>A list of all cash transactions below</span>

      {filteredCashbooks.length > 0 && allData.budget !== undefined? (
        <>
          <DataTable
            title=""
            columns={columns}
            data={calculateBalance()}
            pagination
            highlightOnHover
            striped
            responsive
            customStyles={customStyles}
            conditionalRowStyles={[
              {
                when: row => {

                  return parseInt(row.status) === 4;
                }, 
                style: {
                  backgroundColor: 'rgba(255, 0, 0, 0.2)', // light red background
                  color: 'red', // red text (optional)
                },
              },
            ]}
          />
          <div className="text-right font-bold mt-2">
            Final Balance: {formatToZMW(finalBalance)}
          </div>
        </>
      ) : (
        <div className="flex flex-col justify-center items-center">
                                  <FaFolderOpen className="text-gray-500 text-6xl mb-2" />
                                  <p className="text-gray-600">No cash records found</p>
                                </div>
      )}

 {/* Delete Confirmation Modal */}
 {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-md shadow-lg w-96">
            <h2 className="text-lg font-semibold">Enter a Comment</h2>
            <textarea
              className="w-full p-2 border rounded-md mt-2"
              rows="3"
              placeholder="Write a reason for deletion..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            ></textarea>
            <div className="mt-4 flex justify-end gap-2">
              <button
                onClick={() => setIsOpen(false)}
                className="px-4 py-2 border rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="px-4 py-2 bg-blue-500 text-white rounded-md"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

{showSlidingDiv && (
  <div
    id="slidingDiv"
    className="bg-white fixed top-0 right-0 h-full w-3/4 overflow-auto shadow-lg"
  >
    <FaTimes
      onClick={closeSlidingDiv}
      className="p-1 m-1 text-2xl text-red-500 float-right cursor-pointer"
    />

    <h3 className="m-2 font-semibold text-lg">{title}</h3>
    <hr />

    <div className="flex gap-4 p-4">
      {/* <ReactToPrint
        trigger={() => (
          <button className="bg-blue-500 text-white px-4 py-2 rounded">
            Print
          </button>
        )}
        content={() => componentRef.current}
      /> */}
      <button
        onClick={handleExportToPDF}
        className="bg-blue-950 text-white px-4 py-2 rounded float-right"
      >
        <FaFilePdf/>
      </button>

      <button
        onClick={handlePrint}
        className="bg-blue-950 text-white px-4 py-2 rounded float-right"
      >
        <FaPrint/>
      </button>

      
    </div>
    <div id="form" ref={componentRef}>
      {output}
    </div>
  </div>
)}

  {/* Edit Modal */}
  {isEditModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-5 rounded-lg shadow-lg w-1/3">
            <h2 className="text-xl font-semibold mb-4">Edit Entry</h2>
            <label className="block mb-2">Date:</label>
            <input
              type="date"
              name="date"
              value={editData.date}
              onChange={handleChange}
              className="w-full p-2 border rounded mb-3"
            />

            <label className="block mb-2">Description:</label>
            <textarea
              name="description"
              value={editData.description}
              onChange={handleChange}
              className="w-full p-2 border rounded mb-3"
              rows={3}
            />

<label className="block mb-2">Budget:</label>
            <Select
                 options={allData.budget.map(getOptionDetails)}
                placeholder="Select budget"
                onChange={(selected) => handleSelectChange(selected, 'coa_id')}
                value={editData.coa_id}
                className="mb-4"
                isClearable
                                />

     <label className="block mb-2">Project:</label>
            <Select
                options={allData.projects.map((res)=>({value:res.id, label:res.name}))}
                placeholder="Select project"
                onChange={(selected) => handleSelectChange(selected, 'project')}
                value={editData.project}
                className="mb-4"
                isClearable
                                />

<label className="block mb-2">Bank:</label>
            <Select
                options={allData.bank.map((res)=>({value:res.id, label:res.name}))}
                placeholder="Select bank"
                onChange={(selected) => handleSelectChange(selected, 'bank')}
                value={editData.bank}
                className="mb-4"
                isClearable
                                />
{/* 
<label className="block mb-2">Payee:</label>
            <Select
                options={allData.suppliers.map((res)=>({value:res.id, label:res.name + `${res.type==3?' -Customer':' -Supplier'}`}))}
                placeholder="Select payee"
                onChange={(selected) => handleSelectChange(selected, 'paye')}
                value={editData.paye}
                className="mb-4"
                isClearable       /> */}
            <div className="flex justify-end space-x-2">
              <button
                className="bg-gray-500 text-white px-4 py-2 rounded"
                onClick={() => setIsEditModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="bg-blue-600 text-white px-4 py-2 rounded"
                onClick={handleSubmit}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Placeholder */}
      {isModalVisible && (
        <Modal
          title="New Cashbook Entry"
          onClose={() => setIsModalVisible(false)}
        >
          <FormGenerator fields = {fields} onSubmit={onsubmit} /> 
        </Modal>
      )}
    </div>
  );
};

export default CashbookPage;
